import { Icon } from '@chakra-ui/react';

export const ChevronLeftIcon = () => {
	return (
		<Icon
			w="11"
			h="19"
			viewBox="0 0 11 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.40885 17.7441L1.24219 9.74414L9.40885 1.74414"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>{' '}
		</Icon>
	);
};
